import {
  FETCH_CONTENT_SERIES_REQUEST_ERROR,
  FETCH_CONTENT_SERIES_REQUEST_INIT,
  FETCH_CONTENT_SERIES_REQUEST_SUCCESS,
  SET_SEASON_SELECTED,
  CLEAR_SERIE_DATA,
  SHOW_VOD_TRANSACTIONS_MODAL,
  HIDE_VOD_TRANSACTIONS_MODAL,
  SHOW_MENU_SERIES,
  HIDE_MENU_SERIES,
  SHOW_VOD_ANONYMOUS_MODAL,
  SET_EPISODE_INFO,
} from 'containers/Player/actions/series/constants';
import Utils from 'utils/Utils';
import axios from '../../../../services/api/microfwk';
import {
  PLAYER_MODALS_Z_INDEX_DECREASE,
  PLAYER_MODALS_Z_INDEX_INCREASE,
} from '../optionButtons/constants';
import { getClaroAdsKey } from 'utils/claroAds/getClaroAdskey';
import { MULTI_PBI_PATH_SERVICES } from 'api/services/content/paths';
import { HttpClient } from 'api/helpers/HttpClient';
import { getLastEpisode } from 'containers/VodPlayer/components/VodFinPlayerContainer/utils/IsOItTheLastChapter';


export const getContentSerie = (group_id, seasonSelected) => async (
  dispatch,
  getState,
) => {
  const state = getState();
  const claroAdsKey = getClaroAdsKey(getState());
  const { metadata, user } = state;
  try {
    dispatch({ type: FETCH_CONTENT_SERIES_REQUEST_INIT });
    const response = await axios.get('/services/content/serie', {
      params: {
        group_id,
      },
    });
    let { seasons, last_season, id } = response.data.response;
    const currentSeasonNumber = seasonSelected || seasons[0].number;
    const currentSeason = seasons.find(s => s.number === seasonSelected);
    const last_episode = getLastEpisode(seasons)
    const dataSeriesLastEpisodeAndseason =  {id, group_id, last_episode, last_season};
    dispatch({
      type: FETCH_CONTENT_SERIES_REQUEST_SUCCESS,
      data: seasons,
      seasonSelected: currentSeasonNumber,
      loadingMoreData: true,
      dataSeriesLastEpisodeAndseason,
    });

    const data = new FormData();
    if (user?.token && !claroAdsKey) data.append('token', `${user.token}`);
    const ids = currentSeason.episodes.map(cs => cs.id);
    data.append('extra_params', JSON.stringify({ group_ids: ids }));
    let r = '';
    const url = claroAdsKey ? MULTI_PBI_PATH_SERVICES : '/services/payway/paymentservice/multipurchasebuttoninfo'
    const apiCall = new HttpClient({ hasClaroAdActive: claroAdsKey });

    try {
      r = await apiCall.post( url
        ,
        data,
      );
    } catch (error) {
      console.log('Error', error);
    }

    if (user?.userhash) {
      console.log('Ejecuta api getbookmark');
      try {
        const bookmarkPromises = seasons?.map(season => {
          const groups = season?.episodes?.reduce(
            (a, b) => (a === '' ? b?.id : `${a},${b?.id}`),
            '',
          );
          return axios.get('/services/user/getbookmark', {
            params: {
              group_id: groups,
              filterlist: Utils?.getNewFilters(metadata),
              user_hash: user?.userhash,
              lasttouch: localStorage.getItem('lasttouchSeen'),
            },
          });
        });
        const bookmarkResponses = await Promise.all(bookmarkPromises);
        seasons = seasons?.map((s, i) => {
          s.bookmark = bookmarkResponses?.[i]?.data?.response?.groups;
          return s;
        });
      } catch (error) {
        console.log('error getbookmark', error);
      }
    }

    dispatch({
      type: FETCH_CONTENT_SERIES_REQUEST_SUCCESS,
      data: seasons,
      seasonSelected: currentSeasonNumber,
      loadingMoreData: true,
      dataSeriesLastEpisodeAndseason,
    });

    currentSeason.episodes.forEach((episode, i) => {
      currentSeason.episodes[i].pbi = r?.data?.data?.listButtons[episode.id];
    });

    currentSeason.PBIINSeasonCalled = true;
    dispatch({
      type: FETCH_CONTENT_SERIES_REQUEST_SUCCESS,
      data: seasons,
      seasonSelected: currentSeasonNumber,
      loadingMoreData: false,
      dataSeriesLastEpisodeAndseason,
    });
  } catch (e) {
    dispatch({
      type: FETCH_CONTENT_SERIES_REQUEST_ERROR,
    });
  }
};

export const setSeasonSelected = (seasonSelected, cb) => async (
  dispatch,
  getState,
) => {
  const { Player } = getState();
  const seasons = Player.Series.data;
  const currentSeason = seasons.find(s => s.number === seasonSelected);
  const claroAdsKey = getClaroAdsKey(getState());
  dispatch({
    type: SET_SEASON_SELECTED,
    seasonSelected,
    loadingMoreData: true,
  });

  if (currentSeason.PBIINSeasonCalled) {
    dispatch({
      type: SET_SEASON_SELECTED,
      seasonSelected,
      loadingMoreData: false,
    });
  }
  if (!currentSeason.PBIINSeasonCalled) {
    const state = getState();
    const { user } = state;

    const data = new FormData();
    if (user?.token && !claroAdsKey) data.append('token', `${user.token}`);
    const ids = currentSeason.episodes.map(cs => cs.id);
    data.append('extra_params', JSON.stringify({ group_ids: ids }));
    const url = claroAdsKey ? MULTI_PBI_PATH_SERVICES : '/services/payway/paymentservice/multipurchasebuttoninfo'
    const apiCall = new HttpClient({ hasClaroAdActive: claroAdsKey });
    const r = await apiCall.post( url,
      data,
    );

    currentSeason.episodes.forEach((episode, i) => {
      currentSeason.episodes[i].pbi = r?.data?.data?.listButtons[episode.id];
    });

    currentSeason.PBIINSeasonCalled = true;
    dispatch({
      type: SET_SEASON_SELECTED,
      seasonSelected,
      loadingMoreData: false,
    });
  }

  /**/
};

export const clearSerieData = () => ({
  type: CLEAR_SERIE_DATA,
});

export const showVodTransactionsModal = pbi => ({
  type: SHOW_VOD_TRANSACTIONS_MODAL,
  payload: pbi,
});

export const hideVodTransactionsModal = () => ({
  type: HIDE_VOD_TRANSACTIONS_MODAL,
});

export const showMenuSeries = () => dispatch => {
  dispatch({
    type: PLAYER_MODALS_Z_INDEX_INCREASE,
  });
  dispatch({
    type: SHOW_MENU_SERIES,
  });
};

export const hideMenuSeries = () => (dispatch, getState) => {
  const state = getState();
  if (state.Player.Series.seriesMenu.show) {
    dispatch({
      type: HIDE_MENU_SERIES,
    });
    dispatch({
      type: PLAYER_MODALS_Z_INDEX_DECREASE,
    });
  }
};

export const showVodAnonymousModal = showModal => dispatch => {
  dispatch({
    type: SHOW_VOD_ANONYMOUS_MODAL,
    payload: showModal,
  });
};

export const setEpisodeInfo = epidoseInfo => dispatch => {
  dispatch({
    type: SET_EPISODE_INFO,
    payload: epidoseInfo,
  });
};
